import { IonText } from '@ionic/react';
import { memo } from 'react';

const Text = memo(IonText);

export default Text;
